import React from 'react';

const TermsOfUsePage: React.FC = () => {

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto bg-white rounded-xl shadow-md overflow-hidden p-8">
        <div className="text-center mb-10 border-b pb-6">
          <h1 className="text-4xl font-bold text-gray-900 mb-2">Términos de Uso</h1>
          <p className="text-lg text-gray-600">Lea cuidadosamente antes de usar este sitio web</p>
        </div>

        <div className="prose prose-lg max-w-none text-gray-700 leading-relaxed space-y-6">
          <div className="bg-blue-50 p-6 rounded-lg border-l-4 border-blue-500">
            <p className="font-bold text-lg text-blue-800 mb-2">LEGAL – TÉRMINOS DE USO</p>
            <p className="mb-4">
              Lea cuidadosamente antes de usar este sitio web
            </p>
          </div>

          <section>
            <p className="mb-4">
              Bienvenido al sitio web de Realtypy (realtypy.com). Los objetivos de este sitio web incluyen proporcionar a los consumidores
              acceso a información sobre listados, propiedades y terrenos en venta y en alquiler a través de Realtypy y sus agentes asociados,
              así como información relacionada con el sector de bienes raíces que creemos puede ser de interés para usted. Para asegurar un
              entorno seguro y profesional para todos los visitantes, hemos establecido estos "Términos de Uso". Al acceder a cualquier área
              de realtypy.com, usted acepta estar sujeto a los términos y condiciones establecidos a continuación. Si no está de acuerdo con
              todos los Términos de Uso, le solicitamos no utilizar este sitio.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mt-8 mb-4 text-gray-800 border-b pb-2 pt-4 flex items-center">
              <span className="mr-3 bg-gray-200 text-gray-700 rounded-full w-8 h-8 flex items-center justify-center text-sm">1</span>
              AVISO DE COPYRIGHT (Derechos de Autor)
            </h2>
            <p className="mb-4">
              Los materiales en este sitio web, así como la organización y el diseño del mismo, son propiedad de Realtypy y están protegidos
              por las leyes de derechos de autor y las disposiciones de tratados internacionales vigentes.
            </p>

            <p className="mb-4">
              Puede acceder, descargar e imprimir materiales de este sitio web únicamente para su uso personal y no comercial. Sin embargo,
              cualquier impresión de este sitio web, o partes del mismo, debe conservar el aviso de copyright o propiedad de Realtypy. No se
              le transfiere ningún derecho, título o interés en ninguno de los materiales contenidos en este sitio web como resultado del
              acceso, descarga o impresión de dichos materiales.
            </p>

            <p className="mb-4">
              A menos que se especifique lo contrario, no está permitido copiar, modificar, distribuir, transmitir, mostrar, reproducir,
              publicar, licenciar, crear trabajos derivados, enlazar o enmarcar en otro sitio web, utilizar en cualquier otro sitio web,
              transferir o vender cualquier información obtenida desde este sitio sin permiso previo y por escrito de Realtypy. Esta prohibición
              incluye expresamente, pero no se limita a, las prácticas de "raspado de pantalla" (screen scraping) o "raspado de base de datos"
              (database scraping) para obtener listas de usuarios, propiedades u otra información.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mt-8 mb-4 text-gray-800 border-b pb-2 pt-4 flex items-center">
              <span className="mr-3 bg-gray-200 text-gray-700 rounded-full w-8 h-8 flex items-center justify-center text-sm">2</span>
              MARCAS COMERCIALES
            </h2>
            <p className="mb-4">
              El nombre Realtypy, el logotipo de la empresa, el diseño del sitio y cualquier eslogan comercial utilizado en la plataforma
              son marcas de servicio y/o marcas registradas propiedad de Realtypy. Estas marcas no se pueden usar de ninguna manera (incluyendo
              publicidad o vínculos a otros sitios) sin recibir el permiso expreso previo y por escrito de Realtypy.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mt-8 mb-4 text-gray-800 border-b pb-2 pt-4 flex items-center">
              <span className="mr-3 bg-gray-200 text-gray-700 rounded-full w-8 h-8 flex items-center justify-center text-sm">3</span>
              ENLACES (LINKS)
            </h2>
            <p className="mb-4">
              Para su comodidad, Realtypy puede proporcionar enlaces a otros sitios web que pueden ser de su interés. Sin embargo, Realtypy no
              controla dichos sitios externos y no es responsable de su contenido, exactitud o confiabilidad de cualquier información, datos,
              opiniones, consejos o declaraciones contenidas en ellos.
            </p>

            <p className="mb-4">
              Además, la política de privacidad de Realtypy solo se aplica mientras usted se encuentra en nuestro dominio (realtypy.com).
              Una vez que se vincula a otro sitio web, debe leer la política de privacidad de ese sitio antes de divulgar cualquier información
              personal. Si decide acceder a cualquiera de los sitios de terceros vinculados, lo hace bajo su propio riesgo. Realtypy se reserva
              el derecho de cancelar cualquier enlace en cualquier momento.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mt-8 mb-4 text-gray-800 border-b pb-2 pt-4 flex items-center">
              <span className="mr-3 bg-gray-200 text-gray-700 rounded-full w-8 h-8 flex items-center justify-center text-sm">4</span>
              RENUNCIA DE RESPONSABILIDAD (DISCLAIMER)
            </h2>
            <div className="bg-yellow-50 p-4 rounded-lg border-l-4 border-yellow-500 mb-4">
              <p className="font-bold text-yellow-800 mb-2">
                LOS MATERIALES CONTENIDOS EN ESTE SITIO WEB SE PROPORCIONAN "TAL CUAL" Y "SEGÚN DISPONIBILIDAD", SIN REPRESENTACIONES O
                GARANTÍAS DE NINGÚN TIPO. REALTYPY RECHAZA EXPRESAMENTE TODAS DICHAS REPRESENTACIONES Y GARANTÍAS, YA SEAN EXPRESAS O IMPLÍCITAS,
                INCLUYENDO SIN LIMITACIÓN GARANTÍAS DE TÍTULO, NO INFRACCIÓN, O GARANTÍAS IMPLÍCITAS DE COMERCIABILIDAD O IDONEIDAD PARA UN FIN
                DETERMINADO.
              </p>
            </div>

            <p className="mb-4">
              REALTYPY NO GARANTIZA LA EXACTITUD O INTEGRIDAD DE LA INFORMACIÓN, TEXTO, GRÁFICOS, ENLACES U OTROS ELEMENTOS CONTENIDOS EN ESTOS
              MATERIALES. REALTYPY PUEDE HACER CAMBIOS A ESTE SITIO WEB EN CUALQUIER MOMENTO SIN PREVIO AVISO. AUNQUE NOS ESFORZAMOS POR MANTENER
              LA INFORMACIÓN PRECISA Y ACTUAL, NO PODEMOS GARANTIZAR LA EXACTITUD O LA OPORTUNIDAD DE LA MISMA EN TODO MOMENTO. LA INFORMACIÓN
              DENTRO DEL SITIO WEB PUEDE CONTENER INEXACTITUDES TÉCNICAS O ERRORES TIPOGRÁFICOS. REALTYPY SE RESERVA EL DERECHO DE HACER CAMBIOS,
              CORRECCIONES Y/O MEJORAS A LA INFORMACIÓN CONTENIDA EN ESTE SITIO WEB EN CUALQUIER MOMENTO Y SIN PREVIO AVISO.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mt-8 mb-4 text-gray-800 border-b pb-2 pt-4 flex items-center">
              <span className="mr-3 bg-gray-200 text-gray-700 rounded-full w-8 h-8 flex items-center justify-center text-sm">5</span>
              LIMITACIÓN DE RESPONSABILIDAD
            </h2>
            <p className="mb-4">
              EN NINGÚN CASO REALTYPY SERÁ RESPONSABLE DE CUALQUIER DAÑO QUE SURJA DEL USO DEL SITIO WEB O DE LA INCAPACIDAD DE USO DEL MISMO,
              INCLUYENDO, PERO NO LIMITADO A, DAÑOS DIRECTOS, INDIRECTOS, INCIDENTALES, ESPECIALES O CONSECUENTES, INCLUSO SI REALTYPY HA SIDO
              INFORMADO DE LA POSIBILIDAD DE DICHOS DAÑOS. DADO QUE ALGUNAS JURISDICCIONES PROHIBEN LA EXCLUSIÓN O LIMITACIÓN DE RESPONSABILIDAD
              POR DAÑOS CONSECUENTES O INCIDENTALES, ES POSIBLE QUE LA LIMITACIÓN ANTERIOR NO SE APLIQUE A USTED EN SU TOTALIDAD.
            </p>
          </section>
        </div>

        <div className="mt-12 text-center text-gray-500 text-sm">
          <p>Última actualización: {new Date().toLocaleDateString('es-ES')}</p>
        </div>
      </div>
    </div>
  );
};

export default TermsOfUsePage;